const AppConsts = {
  maritalStatus: '1',
  occupationGroup: '1',
  responseDescription: 'true',
  agentNumber1: '00500813',
  agentNumber2: '11111',
  male: 'MALE',
  maintariffType: 'ADDITIONAL',
  orderWaitingSubmit: 'ORDER_WAITING_SUBMIT',
  orderDataIncomplete: 'ORDER_DATA_INCOMPLET',
  orderDatacomplete: 'ORDER_DATA_COMPLETED',
  orderAccepted: 'ORDER_ACCEPTED',
};

export const trackingIdsByMandant = {
  levelnine: 'G-NXPJYXRKKM',
  vmk: 'G-F4DSR3FDQ4',
  sdk: 'G-T0H48RVZ0Y',
  hallesche: 'G-SDLEDEMP7T',
};

export const gtmContainerIdByMandant: Partial<Record<string, string>> = {
  sdk: 'GTM-W7T5CRC9',
};

export interface ConsentServiceNames {
  ga: string;
}

export const consentServiceNamesByMandant: Partial<Record<string, ConsentServiceNames>> = {
  sdk: {
    ga: 'Google Analytics',
  },
};
export default AppConsts;
